<template>
  <div>
      <b-form-group class="input-group-var-abs" label="ABS:" label-size="sm" label-for="input-var-abs"  label-cols="4">
        <b-form-select required size="sm" id="input-var-abs" class="var-abs" v-model="abs" :options="opcionsAbs"  @input="onUpdateAbs">
           <template v-slot:first>
            <b-form-select-option :value="null">Cap</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>      
  </div>
</template>

<script>
export default {
  name: "VariableAbs",
  props: {
    initialValue:{      
      required: false
    }
 },  
  data() {
    return {
      codiVariable : 'abs',
      abs: null,
      //DEPENDIENDO DE LA REGIO SANITARIA SE LLENARAN DE X O Y
      opcionsAbs:[
         { value: 'abrera', text: 'Abrera' },
         { value: 'agramunt', text: 'Agramunt'},
         { value: 'alcarras', text: 'Alcarràs' },
         { value: 'alfarras-almenar', text: 'Alfarràs-Almenar' },
         { value: 'almacelles', text: 'Almacelles' },
         { value: 'alt-bergueda', text: 'Alt Bergueda' },
         { value: 'alt-camp-est', text: 'Alt Camp - Est' },
         { value: 'alt-camp-oest', text: 'Alt Camp - Oest' },
         { value: 'alt-mogent', text: 'Alt Mogent' },
         { value: 'alt-urgell-sud', text: 'Alt Urgell - Sud' },
         { value: 'alta-ribagorca', text: 'Alta Ribagorca' },
         { value: 'amposta', text: 'Amposta' },
         { value: 'angles', text: 'Anglès' },
         { value: 'anoia-rural', text: 'Anoia rural' },
         { value: 'aran', text: 'Aran' },
         { value: 'arbucies-sant-hilari', text: 'Arbúcies-Sant Hilari' },
         { value: 'arenys-mar', text: 'Arenys de mar' },
         { value: 'argentona', text: 'Argentona' },
         { value: 'artes', text: 'Artès' },
         { value: 'artesa-segre', text: 'Artesa de Segre' },
         { value: 'badalona1', text: 'Badalona 1' },
         { value: 'badalona2', text: 'Badalona 2' },
         { value: 'badalona3', text: 'Badalona 3' },
         { value: 'badalona4', text: 'Badalona 4' },
         { value: 'badalona5', text: 'Badalona 5' },
         { value: 'badalona6', text: 'Badalona 6' },
         { value: 'badalona7a', text: 'Badalona 7a' },
         { value: 'badalona7b', text: 'Badalona 7b' },
         { value: 'badalona8', text: 'Badalona 8' },
         { value: 'badalona9', text: 'Badalona 9' },
         { value: 'badalona10', text: 'Badalona 10' },
         { value: 'badalona11', text: 'Badalona 11' },
         { value: 'badalona12', text: 'Badalona 12' },
         { value: 'baix-bergueda', text: 'Baix Berguedà' },
         { value: 'baix-penedes-interior', text: 'Baix Penedès - interior' },
         { value: 'balaguer', text: 'Balaguer' },
         { value: 'banyoles', text: 'Banyoles' },
         { value: 'barbera-valles', text: 'Barberà del Vallès' },
         { value: 'barcelona1a', text: 'Barcelona 1a' },
         { value: 'barcelona1b', text: 'Barcelona 1b' },
         { value: 'barcelona1c', text: 'Barcelona 1c' },
         { value: 'barcelona1d', text: 'Barcelona 1d' },
         { value: 'barcelona1e', text: 'Barcelona 1e' },
         { value: 'barcelona2a', text: 'Barcelona 2a' },
         { value: 'barcelona2b', text: 'Barcelona 2b' },
         { value: 'barcelona2c', text: 'Barcelona 2c' },
         { value: 'barcelona2d', text: 'Barcelona 2d' },
         { value: 'barcelona2e', text: 'Barcelona 2e' },
         { value: 'barcelona2f', text: 'Barcelona 2f' },
         { value: 'barcelona2g', text: 'Barcelona 2g' },
         { value: 'barcelona2h', text: 'Barcelona 2h' },
         { value: 'barcelona2i', text: 'Barcelona 2i' },
         { value: 'barcelona2j', text: 'Barcelona 2j' },
         { value: 'barcelona2k', text: 'Barcelona 2k' },
         { value: 'barcelona3a', text: 'Barcelona 3a' },
         { value: 'barcelona3b', text: 'Barcelona 3b' },
         { value: 'barcelona3c', text: 'Barcelona 3c' },
         { value: 'barcelona3d', text: 'Barcelona 3d' },
         { value: 'barcelona3e', text: 'Barcelona 3e' },
         { value: 'barcelona3f', text: 'Barcelona 3f' },
         { value: 'barcelona3g', text: 'Barcelona 3g' },
         { value: 'barcelona3h', text: 'Barcelona 3h' },
         { value: 'barcelona3i', text: 'Barcelona 3i' },
         { value: 'barcelona4a', text: 'Barcelona 4a' },
         { value: 'barcelona4b', text: 'Barcelona 4b' },
         { value: 'barcelona4c', text: 'Barcelona 4c' },
         { value: 'barcelona5a', text: 'Barcelona 5a' },
         { value: 'barcelona5b', text: 'Barcelona 5b' },
         { value: 'barcelona5c', text: 'Barcelona 5c' },
         { value: 'barcelona5d', text: 'Barcelona 5d' },
         { value: 'barcelona5e', text: 'Barcelona 5e' },
         { value: 'barcelona6a', text: 'Barcelona 6a' },
         { value: 'barcelona6b', text: 'Barcelona 6b' },
         { value: 'barcelona6c', text: 'Barcelona 6c' },
         { value: 'barcelona6d', text: 'Barcelona 6d' },
         { value: 'barcelona6e', text: 'Barcelona 6e' },
         { value: 'barcelona7a', text: 'Barcelona 7a' },
         { value: 'barcelona7b', text: 'Barcelona 7b' },
         { value: 'barcelona7c', text: 'Barcelona 7c' },
         { value: 'barcelona7d', text: 'Barcelona 7d' },
         { value: 'barcelona7e', text: 'Barcelona 7e' },
         { value: 'barcelona7f', text: 'Barcelona 7f' },
         { value: 'barcelona7g', text: 'Barcelona 7g' },
         { value: 'barcelona8c', text: 'Barcelona 8c' },
         { value: 'barcelona8f', text: 'Barcelona 8f' },
         { value: 'barcelona8g', text: 'Barcelona 8g' },
         { value: 'barcelona8h', text: 'Barcelona 8h' },
         { value: 'barcelona8i', text: 'Barcelona 8i' },
         { value: 'barcelona8j', text: 'Barcelona 8j' },
         { value: 'barcelona8k', text: 'Barcelona 8k' },
         { value: 'barcelona8l', text: 'Barcelona 8l' },
         { value: 'barcelona9a', text: 'Barcelona 9a' },
         { value: 'barcelona9c', text: 'Barcelona 9c' },
         { value: 'barcelona9e', text: 'Barcelona 9e' },
         { value: 'barcelona9f', text: 'Barcelona 9f' },
         { value: 'barcelona9h', text: 'Barcelona 9h' },
         { value: 'barcelona9i', text: 'Barcelona 9i' },
         { value: 'barcelona10a', text: 'Barcelona 10a' },
         { value: 'barcelona10b', text: 'Barcelona 10b' },
         { value: 'barcelona10c', text: 'Barcelona 10c' },
         { value: 'barcelona10d', text: 'Barcelona 10d' },
         { value: 'barcelona10e', text: 'Barcelona 10e' },
         { value: 'barcelona10f', text: 'Barcelona 10f' },
         { value: 'barcelona10g', text: 'Barcelona 10g' },
         { value: 'barcelona10h', text: 'Barcelona 10h' },
         { value: 'barcelona10i', text: 'Barcelona 10i' },
         { value: 'barcelona10j', text: 'Barcelona 10j' },
         { value: 'bascara', text: 'Bàscara' },
         { value: 'begues', text: 'Begues' },
         { value: 'bellpuig', text: 'Bellpuig' },
         { value: 'berga', text: 'Berga' },
         { value: 'besalu', text: 'Besalú' },
         { value: 'blanes', text: 'Blanes' },
         { value: 'breda-hostalric', text: 'Breda/Hostalric' },
         { value: 'calaf', text: 'Calaf' },
         { value: 'calafell', text: 'Calafell' },
         { value: 'caldes-montbui', text: 'Caldes de Montbui' },
         { value: 'calella', text: 'Calella' },
         { value: 'cambrils', text: 'Cambrils' },
         { value: 'camprodon', text: 'Camprodon' },
         { value: 'canet-mar', text: 'Canet de mar' },
         { value: 'capellades', text: 'Capellades' },
         { value: 'cardedeu', text: 'Cardedeu' },
         { value: 'cardona', text: 'Cardona' },
         { value: 'cassa-selva', text: 'Cassà de la Selva' },
         { value: 'castellar-valles', text: 'Castellar del Vallès' },
         { value: 'castellbisbal', text: 'Castellbisbal' },
         { value: 'castelldefels1', text: 'Castelldefels 1' },
         { value: 'castelldefels2', text: 'Castelldefels 2' },
         { value: 'celra', text: 'Celrà' },
         { value: 'centelles', text: 'Centelles' },
         { value: 'cerdanyola-valles1', text: 'Cerdanyola del Vallès 1' },
         { value: 'cerdanyola-valles2', text: 'Cerdanyola del Vallès 2' },
         { value: 'cerdanyola-ripollet', text: 'Cerdanyola-Ripollet' },
         { value: 'cervera', text: 'Cervera' },
         { value: 'ciutat-badia', text: 'Ciutat Badia' },
         { value: 'constanti', text: 'Constantí' },
         { value: 'corbera-llobregat', text: 'Corbera de Llobregat' },
         { value: 'cornella-llobregat1', text: 'Cornellà de Llobregat 1' },
         { value: 'cornella-llobregat2', text: 'Cornellà de Llobregat 2' },
         { value: 'cornella-llobregat3', text: 'Cornellà de Llobregat 3' },
         { value: 'cornella-llobregat4', text: 'Cornellà de Llobregat 4' },
         { value: 'cornudella-montsant', text: 'Cornudella de Montsant' },
         { value: 'cubelles-cunit', text: 'Cubelles-Cunit' },
         { value: 'deltebre', text: 'Deltebre' },
         { value: 'masnou-alella', text: 'El Masnou-Alella' },
         { value: 'morell', text: 'El Morell' },
         { value: 'prat-llobregat1', text: 'El Prat de Llobregat 1' },
         { value: 'prat-llobregat2', text: 'El Prat de Llobregat 2' },
         { value: 'prat-llobregat3', text: 'El Prat de Llobregat 3' },
         { value: 'solsones', text: 'El Solsonès' },
         { value: 'vendrell', text: 'El Vendrell' },
         { value: 'esparraguera', text: 'Esparraguera' },
         { value: 'esplugues-llobregat1', text: 'Esplugues de Llobregat 1' },
         { value: 'esplugues-llobregat2', text: 'Esplugues de Llobregat 2' },
         { value: 'falset', text: 'Falset' },
         { value: 'figueres', text: 'Figueres' },
         { value: 'flix', text: 'Flix' },
         { value: 'gava1', text: 'Gavà 1' },
         { value: 'gava2', text: 'Gavà 2' },
         { value: 'girona1', text: 'Girona 1' },
         { value: 'girona2', text: 'Girona 2' },
         { value: 'girona3', text: 'Girona 3' },
         { value: 'girona4', text: 'Girona 4' },
         { value: 'granollers-oest', text: 'Granollers Oest' },
         { value: 'granollers-nord', text: 'Granollers Nord' },
         { value: 'granollers-centre-est', text: 'Granollers Centre-est' },
         { value: 'granollers-sud', text: 'Granollers Sud' },
         { value: 'igualada1', text: 'Igualada 1' },
         { value: 'igualada2', text: 'Igualada 2' },
         { value: 'bisbal-emporda', text: 'La Bisbal d\'Empordà' },
         { value: 'cerdanya', text: 'La Cerdanya' },
         { value: 'garriga', text: 'La Garriga' },
         { value: 'granadella', text: 'La Granadella' },
         { value: 'jonquera', text: 'La Jonquera' },
         { value: 'llagosta', text: 'La Llagosta' },
         { value: 'pobla-segur', text: 'La Pobla de Segur' },
         { value: 'roca-valles', text: 'La Roca del Vallès' },
         { value: 'selva-camp', text: 'La Selva del Camp' },
         { value: 'seu-urgell', text: 'La Seu d\'Urgell' },
         { value: 'aldea-camarles-ampolla', text: 'L\'Aldea-Camarles-Ampolla' },
         { value: 'ametlla-mar-perello', text: 'L\'Ametlla de mar-El Perelló' },
         { value: 'borgues-blanques', text: 'Les Borgues Blanques' },
         { value: 'borges-camp', text: 'Les Borges del Camp' },
         { value: 'escala', text: 'L\'Escala' },
         { value: 'hospitalet-llobregat-centre', text: 'L\'Hospitalet de Llobregat - Centre' },
         { value: 'hospitalet-llobregat-c-serra', text: 'L\'Hospitalet de Llobregat - C. Serra' },
         { value: 'hospitalet-llobregat-gornal', text: 'L\'Hospitalet de Llobregat - Gornal' },
         { value: 'hospitalet-llobregat-bellvitge', text: 'L\'Hospitalet de Llobregat - Bellvitge' },
         { value: 'hospitalet-llobregat-sant-josep', text: 'L\'Hospitalet de Llobregat - S.Josep' },
         { value: 'hospitalet-llobregat-collblanc', text: 'L\'Hospitalet de Llobregat - Collblanc' },
         { value: 'hospitalet-llobregat-torrassa', text: 'L\'Hospitalet de Llobregat - Torrassa' },
         { value: 'hospitalet-llobregat-eulalia-n', text: 'L\'Hospitalet de Llobregat - Eulàlia N.' },
         { value: 'hospitalet-llobregat-eulalia-s', text: 'L\'Hospitalet de Llobregat - Eulàlia S.' },
         { value: 'hospitalet-llobregat-florida-n', text: 'L\'Hospitalet de Llobregat - Florida N.' },
         { value: 'hospitalet-llobregat-florida-s', text: 'L\'Hospitalet de Llobregat - Florida S.' },
         { value: 'hospitalet-llobregat-pubilla', text: 'L\'Hospitalet de Llobregat - Pubilla C.' },
         { value: 'llanca', text: 'Llançà' },
         { value: 'lleida-centre-historic', text: 'Lleida - Centre Històric' },
         { value: 'lleida-primer-maig', text: 'Lleida - Primer de maig' },
         { value: 'lleida-eixample', text: 'Lleida - Eixample' },
         { value: 'lleida-balafia-pardinyes', text: 'Lleida - Balafia/Pardinyes' },
         { value: 'lledia-cappont', text: 'Lledia - Cappont' },
         { value: 'lledia-bordeta-magraners', text: 'Lledia - Bordeta/Magraners' },
         { value: 'lleida-11-setembre', text: 'Lleida - 11 de setembre' },
         { value: 'lleida-rural-nord', text: 'Lleida - rural nord' },
         { value: 'lleida-rural-sud', text: 'Lleida - rural sud' },
         { value: 'lloret-mar', text: 'Lloret de mar' },
         { value: 'llucanes', text: 'Lluçanès' },
         { value: 'malgrat-mar', text: 'Malgrat de mar' },
         { value: 'manlleu', text: 'Manlleu' },
         { value: 'manresa1', text: 'Manresa 1' },
         { value: 'manresa2', text: 'Manresa 2' },
         { value: 'manresa3', text: 'Manresa 3' },
         { value: 'manresa4', text: 'Manresa 4' },
         { value: 'martorell', text: 'Martorell' },
         { value: 'martorell-rural', text: 'Martorell rural' },
         { value: 'martorelles', text: 'Martorelles' },
         { value: 'mataro1', text: 'Mataró 1' },
         { value: 'mataro2', text: 'Mataró 2' },
         { value: 'mataro3', text: 'Mataró 3' },
         { value: 'mataro4', text: 'Mataró 4' },
         { value: 'mataro5', text: 'Mataró 5' },
         { value: 'mataro6', text: 'Mataró 6' },
         { value: 'mataro7', text: 'Mataró 7' },
         { value: 'moia', text: 'Moià' },
         { value: 'molins-rei', text: 'Molins de Rei' },
         { value: 'mollet-oest', text: 'Mollet Oest' },
         { value: 'mollet-est', text: 'Mollet Est' },
         { value: 'montblanc', text: 'Montblanc' },
         { value: 'montcada-reixac', text: 'Montcada i Reixac' },
         { value: 'montgat', text: 'Montgat' },
         { value: 'montornes-montmelo', text: 'Montornès-Montmeló' },
         { value: 'montroig-camp', text: 'Mont-roig del Camp' },
         { value: 'montserrat', text: 'Montserrat' },
         { value: 'mora-nova-ebre', text: 'Mora la nova/Mora d\'Ebre' },
         { value: 'navarcles-sant-fruitos', text: 'Navarcles - Sant Fruitós el Bages' },
         { value: 'navas-balsareny', text: 'Navas-Balsareny' },
         { value: 'ocata-teia', text: 'Ocata-Teià' },
         { value: 'olesa-montserrat', text: 'Olesa de Montserrat' },
         { value: 'olot', text: 'Olot' },
         { value: 'palafrugell', text: 'Palafrugell' },
         { value: 'palamos', text: 'Palamós' },
         { value: 'palau-solita-plegamans', text: 'Palau-Solità i Plegamans' },
         { value: 'pallars-sobira', text: 'Pallars Sobirà' },
         { value: 'palleja', text: 'Pallejà' },
         { value: 'parets-valles', text: 'Parets del Vallès' },
         { value: 'penedes-rural', text: 'Penedès rural' },
         { value: 'peralada', text: 'Peralada' },
         { value: 'piera', text: 'Piera' },
         { value: 'pineda', text: 'Pineda' },
         { value: 'pla-urgell', text: 'Pla d\'Urgell' },
         { value: 'polinya-sentmenat', text: 'Polinyà-Sentmenat' },
         { value: 'ponts', text: 'Ponts' },
         { value: 'premia-mar', text: 'Premià de mar' },
         { value: 'reus1', text: 'Reus 1' },
         { value: 'reus2', text: 'Reus 2' },
         { value: 'reus3', text: 'Reus 3' },
         { value: 'reus4', text: 'Reus 4' },
         { value: 'reus5', text: 'Reus 5' },
         { value: 'ribes-freser-campdevanol', text: 'Ribes de Freser/Campdevànol' },
         { value: 'ribes-olivella', text: 'Ribes-Olivella' },
         { value: 'ripollet1', text: 'Ripollet 1' },
         { value: 'ripollet2', text: 'Ripollet 2' },
         { value: 'ripoll-sant-joan-abadesses', text: 'Ripoll/Sant Joan de les Abadesses' },
         { value: 'riudoms', text: 'Riudoms' },
         { value: 'roda-ter', text: 'Roda de Ter' },
         { value: 'roquetes-canyelles', text: 'Roquetes-Canyelles' },
         { value: 'roses', text: 'Roses' },
         { value: 'rubi1', text: 'Rubí 1' },
         { value: 'rubi2', text: 'Rubí 2' },
         { value: 'rubi3', text: 'Rubí 3' },
         { value: 'sabadell1a', text: 'Sabadell 1a' },
         { value: 'sabadell1b', text: 'Sabadell 1b' },
         { value: 'sabadell2', text: 'Sabadell 2' },
         { value: 'sabadell3a', text: 'Sabadell 3a' },
         { value: 'sabadell3b', text: 'Sabadell 3b' },
         { value: 'sabadell4a', text: 'Sabadell 4a' },
         { value: 'sabadell4b', text: 'Sabadell 4b' },
         { value: 'sabadell5', text: 'Sabadell 5' },
         { value: 'sabadell6', text: 'Sabadell 6' },
         { value: 'sabadell7', text: 'Sabadell 7' },
         { value: 'sallent', text: 'Sallent' },
         { value: 'salou', text: 'Salou' },
         { value: 'salt', text: 'Salt' },
         { value: 'sant-adria-besos1', text: 'Sant Adrià del Besòs 1' },
         { value: 'sant-adria-besos2', text: 'Sant Adrià del Besòs 2' },
         { value: 'sant-andreu-barca', text: 'Sant Andreu de la Barca' },
         { value: 'sant-andreu-llavaneres', text: 'Sant Andreu de Llavaneres' },
         { value: 'sant-boi1', text: 'Sant Boi de Llobregat 1' },
         { value: 'sant-boi2', text: 'Sant Boi de Llobregat 2' },
         { value: 'sant-boi3', text: 'Sant Boi de Llobregat 3' },
         { value: 'sant-boi4', text: 'Sant Boi de Llobregat 4' },
         { value: 'sant-carles-rapita', text: 'Sant Carles de la Ràpita' },
         { value: 'sant-celoni', text: 'Sant Celoni' },
         { value: 'sant-cugat1', text: 'Sant Cugat 1' },
         { value: 'sant-cugat2', text: 'Sant Cugat 2' },
         { value: 'sant-cugat3', text: 'Sant Cugat 3' },
         { value: 'sant-feliu-guixols', text: 'Sant Feliu de Guíxols' },
         { value: 'sant-feliu-llobregat1', text: 'Sant Feliu de Llobregat1' },
         { value: 'sant-feliu-llobregat2', text: 'Sant Feliu de Llobregat2' },
         { value: 'sant-hipolit-voltrega', text: 'Sant Hipòlit de Voltregà' },
         { value: 'sant-joan-vilatorrada', text: 'Sant Joan de Vilatorrada' },
         { value: 'sant-joan-despi1', text: 'Sant Joan Despí 1' },
         { value: 'sant-joan-despi2', text: 'Sant Joan Despí 2' },
         { value: 'sant-joan-fonts', text: 'Sant Joan les Fonts' },
         { value: 'sant-just-desvern', text: 'Sant Just Desvern' },
         { value: 'sant-quirze-besora', text: 'Sant Quirze de Besora' },
         { value: 'sant-quirze-valles', text: 'Sant Quirze del Vallès' },
         { value: 'sant-sadurni-anoia', text: 'Sant Sadurní d\'Anoia' },
         { value: 'sant-vicenc-castellet', text: 'Sant Vicenç de Castellet' },
         { value: 'sant-vicenc-horts1', text: 'Sant Vicenç dels Horts 1' },
         { value: 'sant-vicenc-horts2', text: 'Sant Vicenç dels Horts 2' },
         { value: 'santa-coloma-farners', text: 'Santa Coloma de Farners' },
         { value: 'santa-coloma-gramenet1', text: 'Santa Coloma de Gramenet 1' },
         { value: 'santa-coloma-gramenet2', text: 'Santa Coloma de Gramenet 2' },
         { value: 'santa-coloma-gramenet3', text: 'Santa Coloma de Gramenet 3' },
         { value: 'santa-coloma-gramenet4', text: 'Santa Coloma de Gramenet 4' },
         { value: 'santa-coloma-gramenet5', text: 'Santa Coloma de Gramenet 5' },
         { value: 'santa-coloma-gramenet6', text: 'Santa Coloma de Gramenet 6' },
         { value: 'santa-coloma-queralt', text: 'Santa Coloma de Queralt' },
         { value: 'santa-eugenia-berga', text: 'Santa Eugènia de Berga' },
         { value: 'santa-margarida-montbui', text: 'Santa Margarida de Montbui' },
         { value: 'santa-perpetua-moguda', text: 'Santa Perpètua de Moguda' },
         { value: 'sarria-ter', text: 'Sarrià de Ter' },
         { value: 'seros', text: 'Seròs' },
         { value: 'sils-vidreres-macanet', text: 'Sils-Vidreres-Maçanet' },
         { value: 'sitges', text: 'Sitges' },
         { value: 'suria', text: 'Súria' },
         { value: 'tarragona1', text: 'Tarragona 1' },
         { value: 'tarragona2', text: 'Tarragona 2' },
         { value: 'tarragona3', text: 'Tarragona 3' },
         { value: 'tarragona4', text: 'Tarragona 4' },
         { value: 'tarragona5', text: 'Tarragona 5' },
         { value: 'tarragona6', text: 'Tarragona 6' },
         { value: 'tarragona7', text: 'Tarragona 7' },
         { value: 'tarragona8', text: 'Tarragona 8' },
         { value: 'tarrega', text: 'Tàrrega' },
         { value: 'terra-alta', text: 'Terra Alta' },
         { value: 'terrassa-a', text: 'Terrassa-a' },
         { value: 'terrassa-b', text: 'Terrassa-b' },
         { value: 'terrassa-c', text: 'Terrassa-c' },
         { value: 'terrassa-d', text: 'Terrassa-d' },
         { value: 'terrassa-e', text: 'Terrassa-e' },
         { value: 'terrassa-f', text: 'Terrassa-f' },
         { value: 'terrassa-g', text: 'Terrassa-g' },
         { value: 'tona', text: 'Tona' },
         { value: 'tordera', text: 'Tordera' },
         { value: 'torredembarra', text: 'Torredembarra' },
         { value: 'torroella-montgri', text: 'Torroella de Montgrí' },
         { value: 'tortosa-est', text: 'Tortosa Est' },
         { value: 'tortosa-oest', text: 'Tortosa Oest' },
         { value: 'tremp', text: 'Tremp' },
         { value: 'ulldecona', text: 'Ulldecona' },
         { value: 'vall-ges', text: 'Vall de Ges' },
         { value: 'vall-tenes', text: 'Vall de Tenes' },
         { value: 'vall-en-bas', text: 'Vall d\'en Bas' },
         { value: 'vallirana', text: 'Vallirana' },
         { value: 'valls-urba', text: 'Valls urbà' },
         { value: 'vandellos-hospitalet-infant', text: 'Vandellòs/Hospitalet de l\'Infant' },
         { value: 'vic-nord', text: 'Vic nord' },
         { value: 'vic-sud', text: 'Vic sud' },
         { value: 'viladecans1', text: 'Viladecans 1' },
         { value: 'viladecans2', text: 'Viladecans 2' },
         { value: 'viladecans3', text: 'Viladecans 3' },
         { value: 'vilafant', text: 'Vilafant' },
         { value: 'vilafranca-penedes-1', text: 'Vilafranca del Penedès 1' },
         { value: 'vilafranca-penedes-2', text: 'Vilafranca del Penedès 2' },
         { value: 'vilanova-cami', text: 'Vilanova del Camí' },
         { value: 'vilanova-geltru1', text: 'Vilanova i la Geltrú 1' },
         { value: 'vilanova-geltru2', text: 'Vilanova i la Geltrú 2' },
         { value: 'vilanova-geltru3', text: 'Vilanova i la Geltrú 3' },
         { value: 'vila-seca', text: 'Vila-seca' },
         { value: 'vilassar-dalt', text: 'Vilassar de Dalt' },
         { value: 'vilassar-mar', text: 'Vilassar de Mar' }
      ]
    };
  },
  computed:{
    returnValue(){
      let r = {codi: this.codiVariable}
      if(this.abs!=null ){
        r.valor = this.abs;
      }

      return r;
    }
  },  
  methods: {    
    onUpdateAbs(newValue){
      console.log(newValue)
      if(this.returnValue.valor){
        this.$emit('variable-editada', this.returnValue)        
      }else{
        this.$emit('variable-eliminada', this.codiVariable)        
      }             
    }
  },
  mounted() {
    if(this.initialValue!=null){
      this.abs = this.initialValue.valor
    }
  }
};
</script>

<style>
.var-abs{
  width: 180px;
}
.input-group-var-abs .col{
  text-align: left;
}
</style>